/**
 * Global 401 handling: session-expiry detection for the shared API client.
 *
 * Kept independent of Vite configuration. client.authRecovery.test.ts exercises
 * the real client with the API origin and identity provider substituted.
 */

/** Window event the App-level listener reacts to (clear cache + bounce to /sign-in?expired=1). */
export const SESSION_EXPIRED_EVENT = 'overlayqa-session-expired';

/**
 * On a 401, decide whether the Clerk session is really gone (expiry, or
 * signed out in another tab) or the request raced the signup bootstrap
 * window (the users row is created JIT by /auth/bootstrap, so a brand-new
 * signup can hit legitimate 401s while a live Clerk session exists).
 *
 * Only the no-session case dispatches the session-expired event; the
 * bootstrap race must NOT bounce a fresh signup to /sign-in. Callers keep
 * throwing ApiError either way, so per-request error handling is unchanged.
 */
export function maybeNotifySessionExpired(status: number): void {
  if (status !== 401) return;
  if (typeof window === 'undefined') return;
  const clerk = (window as Window & { Clerk?: { session?: unknown } }).Clerk;
  if (clerk?.session) return;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}
